import { StyleSheet } from 'react-native';
import theme from '@/constants/colors';
import { Typography } from '@/constants/typography';

export default StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: theme.backgroundPrimary,
  },
  scrollContainer: {
    flex: 1,
  },
  content: {
    paddingHorizontal: 16,
  },
  settingsButton: {
    width: 40,
    height: 40,
    borderRadius: 20,
    backgroundColor: theme.backgroundPrimary,
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 10,
    elevation: 6,
  },
  headerActions: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 4,
  },
  bellButton: {
    width: 40,
    height: 40,
    borderRadius: 20,
    backgroundColor: theme.backgroundPrimary,
    justifyContent: 'center',
    alignItems: 'center',
    position: 'relative',
  },
  badge: {
    position: 'absolute',
    top: 2,
    right: 2,
    backgroundColor: '#FF3B30',
    borderRadius: 8,
    minWidth: 16,
    height: 16,
    justifyContent: 'center',
    alignItems: 'center',
    paddingHorizontal: 4,
  },
  badgeText: {
    color: '#FFFFFF',
    fontSize: 11,
    fontWeight: '700',
  },
  userSection: {
    marginBottom: 16,
  },
  userHeader: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  userAvatar: {
    width: 40,
    height: 40,
    borderRadius: 20,
    overflow: 'hidden',
    backgroundColor: theme.accentPrimary,
    borderWidth: 0,
  },
  userAvatarImage: {
    width: '100%',
    height: '100%',
  },
  familyAvatar: {
    width: 30,
    height: 30,
    borderRadius: 15,
    marginLeft: -13,
    marginTop: -10,
    borderWidth: 2,
    borderColor: theme.backgroundPrimary,
    backgroundColor: theme.backgroundSecondaryVarient,
  },
  userInfo: {
    marginLeft: 16,
    flex: 1,
  },
  userName: {
    ...Typography.label(theme.textPrimary),
    fontSize: 15,
    fontWeight: '700',
    marginBottom: 2,
  },
  userEmailRow: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 6,
  },
  userEmail: {
    ...Typography.caption(theme.textMuted),
    fontSize: 11,
    marginLeft: 6,
  },
  dogCardContainer: {
    marginBottom: 16,
  },
  dogCard: {
    backgroundColor: theme.backgroundSecondary,
    borderRadius: 14,
    paddingTop: 24,
    paddingBottom: 24,
    paddingHorizontal: 8,
    alignItems: 'center',
    borderWidth: 0,
    borderColor: theme.backgroundPrimary,
  },
  dogCardRow: {
    flexDirection: 'row',
    gap: 4,
    alignItems: 'stretch',
    justifyContent: 'space-between',
  },
  dogCardLeft: {
    flex: 4,
    backgroundColor: theme.backgroundSecondary,
    borderRadius: 14,
    paddingVertical: 18,
    paddingHorizontal: 8,
    alignItems: 'center',
    justifyContent: 'center',
    marginRight: 4,
  },
  dogCardRight: {
    flex: 6,
    backgroundColor: theme.backgroundPrimary,
    borderRadius: 14,
    paddingVertical: 18,
    paddingHorizontal: 8,
    justifyContent: 'center',
    marginLeft: 4,
    borderWidth: 2,
    borderColor: theme.backgroundSecondary,
  },
  dogPhotoContainer: {
    marginBottom: 16,
  },
  dogPhotoContainerLeft: {
    marginBottom: 10,
  },
  dogPhotoLarge: {
    width: 88,
    height: 88,
    borderRadius: 44,
    backgroundColor: theme.backgroundSecondaryVarient,
    borderWidth: 0,
    borderColor: theme.accentPrimary,
  },
  dogPhoto: {
    width: 70,
    height: 70,
    borderRadius: 35,
    backgroundColor: theme.backgroundSecondaryVarient,
    borderWidth: 0,
    borderColor: theme.accentPrimary,
  },
  dogPhotoPlaceholder: {
    justifyContent: 'center',
    alignItems: 'center',
  },
  dogName: {
    ...Typography.h2(theme.accentPrimary),
    marginBottom: 4,
  },
  dogNickname: {
    ...Typography.label(theme.textMuted),
    opacity: 0.9,
    marginBottom: 16,
  },
  dogBreed: {
    ...Typography.label(theme.textMuted),
    opacity: 0.9,
    marginBottom: 16,
    textAlign: 'center',
  },
  nicknameSpacing: {
    height: 16,
  },
  dogSection: {
    marginBottom: 16,
  },
  dogSectionHeader: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: 10,
  },
  dogSectionTitle: {
    ...Typography.label(theme.textMuted),
    fontSize: 15,
    fontWeight: '600',
  },
  addDogOutlineButton: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 6,
    paddingHorizontal: 12,
    paddingVertical: 6,
    borderRadius: 6,
    borderWidth: 0.5,
    borderColor: theme.backgroundSecondary,
  },
  addDogOutlineText: {
    ...Typography.caption(theme.textMuted),
    fontSize: 10,
    lineHeight: 10,
    fontWeight: '600',
  },
  dogCarousel: {
    gap: 12,
  },
  dogDots: {
    flexDirection: 'row',
    justifyContent: 'center',
    gap: 6,
    marginTop: 10,
  },
  dogDot: {
    width: 6,
    height: 6,
    borderRadius: 3,
    backgroundColor: theme.textMuted,
    opacity: 0.5,
  },
  dogDotActive: {
    backgroundColor: theme.textPrimary,
    opacity: 1,
  },
  dogCarouselCard: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: theme.backgroundSecondary,
    borderRadius: 14,
    padding: 24,
    borderWidth: 0.5,
    borderColor: 'rgba(255, 255, 255, 0.08)',
  },
  dogCarouselPhoto: {
    width: 70,
    height: 70,
    borderRadius: 35,
    backgroundColor: theme.backgroundSecondaryVarient,
  },
  dogCarouselName: {
    ...Typography.h2(theme.textPrimary),
    fontSize: 26,
    fontWeight: '700',
    marginBottom: 2,
  },
  dogCarouselBreed: {
    ...Typography.caption(theme.textMuted),
    fontSize: 12,
  },
  statsSection: {
    marginTop: 12,
    backgroundColor: theme.backgroundSecondary,
    borderRadius: 14,
    paddingVertical: 12,
    paddingHorizontal: 24,
  },
  statsRow: {
    flexDirection: 'row',
    justifyContent: 'space-around',
    width: '100%',
    marginBottom: 16,
  },
  statItem: {
    alignItems: 'center',
  },
  /* grid style for new profile stats */
  statsGrid: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    alignItems: 'center',
    width: '100%',
  },
  statBox: {
    flex: 1,
    minWidth: '25%',
    alignItems: 'center',
    paddingVertical: 4,
  },
  statValueLarge: {
    ...Typography.label(theme.textPrimary),
    fontSize: 15,
    fontWeight: '600',
    marginBottom: 6,
  },
  statLabelSmall: {
    ...Typography.caption(theme.textMuted),
    fontSize: 11,
  },
  statValue: {
    ...Typography.h3(theme.accentPrimary),
    marginBottom: 2,
  },
  statLabel: {
    ...Typography.caption(theme.textSecondary),
    opacity: 0.8,
  },
  dogInfoRow: {
    flexDirection: 'row',
    gap: 12,
  },
  dogInfoBadge: {
    backgroundColor: 'rgba(255, 255, 255, 0.2)',
    paddingHorizontal: 16,
    paddingVertical: 8,
    borderRadius: 16,
  },
  dogInfoText: {
    ...Typography.label(theme.textPrimary),
  },
  loadingDogCard: {
    backgroundColor: theme.textPrimary,
    borderRadius: 24,
    padding: 48,
    alignItems: 'center',
    justifyContent: 'center',
    borderWidth: 1,
    borderColor: theme.backgroundPrimary,
  },
  statsCardContainer: {
    marginBottom: 16,
  },
  collectiblesContainer: {
    marginBottom: 16,
    backgroundColor: theme.backgroundSecondary,
    borderRadius: 14,
    padding: 4,
    overflow: 'hidden',
  },
  statsLeft: {
    flex: 1,
  },
  statsBig: {
    ...Typography.h1(theme.accentPrimary),
    fontSize: 50,
    lineHeight: 52,
  },
  statsLabel: {
    ...Typography.h3(theme.accentPrimary),
    marginTop: 6,
  },
  statsHint: {
    ...Typography.caption(theme.textSecondary),
    marginTop: 4,
    fontStyle: 'italic',
  },
  statsRight: {
    width: 110,
    alignItems: 'center',
  },
  badgeCircle: {
    width: 56,
    height: 56,
    borderRadius: 28,
    backgroundColor: theme.accentSecondary,
    justifyContent: 'center',
    alignItems: 'center',
    marginBottom: 8,
  },
  badgeTitle: {
    ...Typography.label(theme.accentPrimary),
  },
  badgeSubtitle: {
    ...Typography.caption(theme.textSecondary),
    marginTop: 2,
  },
  noDogCard: {
    backgroundColor: theme.textPrimary,
    borderRadius: 24,
    padding: 32,
    alignItems: 'center',
    gap: 12,
    borderWidth: 1,
    borderColor: theme.backgroundPrimary,
  },
  noDogText: {
    ...Typography.body(theme.accentPrimary),
    opacity: 0.9,
    textAlign: 'center',
  },
  addDogButton: {
    backgroundColor: theme.backgroundPrimary,
    paddingHorizontal: 20,
    paddingVertical: 12,
    borderRadius: 12,
    marginTop: 8,
  },
  addDogButtonText: {
    ...Typography.label(theme.textPrimary),
    fontSize: 19,
  },
  tabsContainer: {
    flexDirection: 'row',
    marginBottom: 16,
    borderBottomWidth: 2,
    borderBottomColor: theme.backgroundSecondary,
  },
  tab: {
    flex: 1,
    paddingVertical: 12,
    paddingHorizontal: 8,
    alignItems: 'center',
    borderBottomWidth: 2,
    borderBottomColor: 'transparent',
    marginBottom: -2,
  },
  tabActive: {
    borderBottomColor: theme.accentPrimary,
  },
  tabText: {
    ...Typography.label(theme.textMuted),
    fontSize: 14,
    fontWeight: '600',
  },
  tabTextActive: {
    color: theme.accentPrimary,
  },
  tabCount: {
    ...Typography.h3(theme.accentPrimary),
    marginBottom: 2,
  },
  tabCountActive: {
    color: theme.backgroundPrimary,
  },
  trailsSection: {
    marginBottom: 16,
    marginHorizontal: -16,
  },
  horizontalTrailsContainer: {
    gap: 12,
    paddingHorizontal: 16,
  },
  verticalTrailsContainer: {
    gap: 12,
    paddingHorizontal: 16,
  },
  trailCardVertical: {
    width: '100%',
  },
  trailCard: {
    backgroundColor: theme.textPrimary,
    borderRadius: 8,
    width: 350,
    overflow: 'hidden',
    marginBottom: 10,
    shadowColor: theme.backgroundSecondaryVarient,
    shadowOffset: { width: 0, height: 4 },
    shadowOpacity: 0.1,
    shadowRadius: 16,
    elevation: 4,
    position: 'relative',
  },
  trailImage: {
    width: '100%',
    height: 250,
    backgroundColor: theme.backgroundSecondary,
  },
  loadingContainer: {
    paddingVertical: 40,
    alignItems: 'center',
    justifyContent: 'center',
  },
  /* Awards tab */
  awardsSection: {
    paddingHorizontal: 16,
    marginBottom: 24,
  },
  milestoneCard: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 20,
    backgroundColor: theme.backgroundSecondary,
    borderRadius: 14,
    padding: 24,
    borderWidth: 0.5,
    borderColor: 'rgba(255, 255, 255, 0.08)',
    marginBottom: 20,
  },
  milestoneLabel: {
    ...Typography.caption(theme.textMuted),
    fontSize: 11,
    fontWeight: '400',
    textTransform: 'uppercase',
    marginBottom: 6,
  },
  milestoneTitle: {
    ...Typography.h2(theme.textPrimary),
    fontSize: 19,
    fontWeight: '700',
    marginBottom: 14,
  },
  milestoneTrack: {
    height: 4,
    borderRadius: 2,
    backgroundColor: theme.textMuted,
    overflow: 'hidden',
    marginBottom: 8,
  },
  milestoneFill: {
    height: '100%',
    borderRadius: 2,
    backgroundColor: theme.accentPrimary,
  },
  milestoneFooter: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  milestoneCount: {
    ...Typography.caption(theme.textMuted),
    fontSize: 11,
    fontWeight: '400',
  },
  milestonePct: {
    ...Typography.caption(theme.textMuted),
    fontSize: 11,
    fontWeight: '400',
  },
  milestoneArt: {
    width: 50,
    height: 63,
  },
  milestoneArtLocked: {
    opacity: 0.4,
  },
  collectionTitle: {
    ...Typography.h3(theme.textPrimary),
    fontSize: 19,
    fontWeight: '600',
    marginBottom: 12,
  },
  trailGradient: {
    position: 'absolute',
    left: 0,
    right: 0,
    bottom: 0,
    height: 120,
  },
  bookmarkButton: {
    position: 'absolute',
    top: 12,
    right: 12,
    width: 44,
    height: 44,
    borderRadius: 22,
    backgroundColor: 'rgba(255,255,255,0.95)',
    justifyContent: 'center',
    alignItems: 'center',
    borderWidth: 1,
    borderColor: theme.backgroundSecondary,
  },
  trailContent: {
    position: 'absolute',
    left: 12,
    right: 12,
    bottom: 12,
    padding: 12,
  },
  trailContentBelow: {
    padding: 12,
    backgroundColor: theme.backgroundSecondary,
  },
  trailName: {
    ...Typography.h2(theme.textPrimary),
    marginBottom: 4,
  },
  trailLocation: {
    ...Typography.caption(theme.textPrimary),
    opacity: 0.95,
  },
  trailBadges: {
    flexDirection: 'row',
    gap: 8,
    marginTop: 8,
  },
  trailBadge: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 6,
    backgroundColor: 'rgba(255,255,255,0.08)',
    paddingHorizontal: 8,
    paddingVertical: 6,
    borderRadius: 12,
  },
  trailBadgeText: {
    ...Typography.caption(theme.textPrimary),
  },
  emptyText: {
    ...Typography.body(theme.textPrimary),
    opacity: 0.7,
    textAlign: 'center',
    lineHeight: 24,
  },
  emptyContainer: {
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: theme.backgroundSecondary,
    borderRadius: 12,
    marginHorizontal: 12,
    padding: 40,
    minHeight: 200,
    marginBottom: 60,
  },
  signOutButton: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 12,
    backgroundColor: theme.accentPrimary,
    borderRadius: 12,
    padding: 16,
    marginTop: 16,
    borderWidth: 1,
    borderColor: theme.accentPrimary,
  },
  signOutButtonDisabled: {
    opacity: 0.6,
  },
  signOutText: {
    ...Typography.label(theme.backgroundPrimary),
  },
  modalContainer: {
    flex: 1,
    backgroundColor: theme.backgroundPrimary,
  },
  modalHeader: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingHorizontal: 20,
    paddingBottom: 20,
    backgroundColor: theme.backgroundPrimary,
    borderBottomWidth: 1,
    borderBottomColor: theme.accentPrimary,
  },
  modalTitle: {
    ...Typography.h2(theme.textPrimary),
  },
  closeButton: {
    width: 40,
    height: 40,
    borderRadius: 20,
    backgroundColor: theme.accentPrimary,
    justifyContent: 'center',
    alignItems: 'center',
  },
  inputLabel: {
    ...Typography.label(theme.backgroundPrimary),
    marginBottom: 8,
  },
  input: {
    backgroundColor: theme.backgroundPrimary,
    borderRadius: 12,
    padding: 16,
    color: theme.textPrimary,
    borderWidth: 1,
    borderColor: theme.accentPrimary,
  },
  initialAvatar: {
    width: '100%',
    height: '100%',
    backgroundColor: theme.accentPrimary,
    justifyContent: 'center',
    alignItems: 'center',
  },
  initialAvatarText: {
    ...Typography.h1(theme.textPrimary),
  },
  /* Modal / Edit profile styles */
  modalContent: {
    paddingHorizontal: 16,
    paddingTop: 16,
    paddingBottom: 80,
  },
  photoSection: {
    alignItems: 'center',
    marginBottom: 20,
  },
  photoContainer: {
    width: 120,
    height: 120,
    borderRadius: 60,
    overflow: 'hidden',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: theme.accentPrimary,
    borderWidth: 3,
    borderColor: theme.backgroundPrimary,
  },
  editPhoto: {
    width: '100%',
    height: '100%',
  },
  cameraOverlay: {
    position: 'absolute',
    right: 8,
    bottom: 8,
    width: 36,
    height: 36,
    borderRadius: 18,
    backgroundColor: theme.backgroundPrimary + '22',
    justifyContent: 'center',
    alignItems: 'center',
  },
  photoHint: {
    ...Typography.caption(theme.textMuted),
    marginTop: 8,
  },
  inputSection: {
    marginBottom: 16,
  },
  disabledInput: {
    backgroundColor: theme.backgroundPrimary,
    borderRadius: 12,
    padding: 12,
    borderWidth: 1,
    borderColor: theme.accentPrimary,
  },
  disabledInputText: {
    ...Typography.label(theme.backgroundPrimary),
    opacity: 0.8,
  },
  inputHint: {
    ...Typography.caption(theme.textMuted),
    marginTop: 6,
  },
  modalFooter: {
    paddingHorizontal: 16,
    paddingTop: 12,
    borderTopWidth: 1,
    borderTopColor: theme.accentPrimary,
    backgroundColor: theme.backgroundPrimary,
  },
  saveButton: {
    backgroundColor: theme.backgroundPrimary,
    paddingVertical: 14,
    borderRadius: 12,
    alignItems: 'center',
    justifyContent: 'center',
  },
  saveButtonDisabled: {
    opacity: 0.6,
  },
  saveButtonText: {
    ...Typography.button(theme.textPrimary),
  },
});
